<template>
  <div class="my-schedule">
    <page-header title="活动作业" />
    <el-form ref="form" :inline="true" :model="search" class="my-schedule-table" style="margin-top: 20px">
      <el-form-item label="名称" prop="activityHomework.title">
        <el-input v-model="search.activityHomework.title"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <ming-table v-model="data" v-loading="isLoading" :fields="column">
      <template #start_time="{ scope }">
        开始： {{ moment(scope.start_time * 1000).format('YYYY-MM-DD HH:mm') }} <br />
        结束：{{ moment(scope.end_time * 1000).format('YYYY-MM-DD HH:mm') }}
      </template>
      <template #fileState="{ scope }">
        <template v-if="scope.end_time * 1000 < Date.now()"> 已截止 </template>
        <template v-else-if="scope.start_time * 1000 > Date.now()"> 未开始 </template>
        <template v-else>
          {{ scope.homework_score_file && scope.homework_score_file.length ? '已提交' : '未提交' }}
        </template>
      </template>
      <template #options="{ scope }">
        <template v-if="scope.end_time * 1000 < Date.now()">
          <el-button type="text" @click="handleOpen(scope)">查看</el-button>
        </template>
        <template v-else-if="scope.start_time * 1000 > Date.now()">
          <el-button type="text" disabled>提交</el-button>
        </template>
        <template v-else>
          <el-button type="text" @click="handleOpen(scope)">{{ scope.homework_score_file && scope.homework_score_file.length ? '重新提交' : '提交' }}</el-button>
        </template>
      </template>
    </ming-table>

    <!-- <el-dialog v-model="dialogVisible" title="Tips" width="500" :before-close="handleClose">
      <span>This is a message</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="dialogVisible = false"> Confirm </el-button>
        </div>
      </template>
    </el-dialog> -->

    <el-dialog
      :title="`提交作业【${homeWorkInfo.title}】`"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <!-- {{ homeWorkInfo }} -->
      <template v-if="homeWorkInfo.demand">
        <div>
          <strong>作业要求</strong>
        </div>
        <p style="white-space: pre-line">
          {{ homeWorkInfo.demand }}
        </p>
      </template>

      <template v-if="homeWorkInfo.demand_file && homeWorkInfo.demand_file.length > 0">
        <p>
          <strong>作业要求附件</strong>
        </p>
        <p v-for="(item, index) in homeWorkInfo.demand_file" :key="index">
          <a :href="item.url" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: red"> {{ item.name }} </a>
        </p>
      </template>

      <!-- 作业上传 组件 -->
      <el-form v-if="dialogVisible" ref="fileFormRef" :key="fileForm.key" :model="fileForm" :rules="rules" class="demo-ruleForm" lable-position="top">
        <el-form-item prop="file">
          <upload-component
            :is-disabled="homeWorkInfo.end_time * 1000 < Date.now()"
            :accept-type="homeWorkInfo.format?.map(el => `.${el}`).join(',')"
            button-text="上传作业"
            :file-list="fileForm.file"
            :limit-num="homeWorkInfo.max_upload_number"
            :extend-updata="extendUpdata"
          >
          </upload-component>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose()">取 消</el-button>
        <el-button v-if="homeWorkInfo.end_time * 1000 > Date.now()" size="small" type="primary" :loading="isSubmitLoading" @click="SubmitEvent()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { ref, onMounted } from 'vue'
import moment from 'moment'
import API from '@/api'
import Store from '@/store'
import UploadComponent from '@/components/UploadComponent'
import { Message } from 'element-ui'
const column = [
  {
    label: '作业名称',
    field: 'title'
  },
  {
    label: '作业上传时间',
    field: 'start_time',
    slot: true
  },
  {
    label: '状态',
    field: 'fileState',
    slot: true,
    width: 100
  },
  {
    label: '操作',
    field: 'options',
    width: '80px',
    slot: true
  }
]
const fileForm = ref({
  file: []
})
const rules = ref({
  file: [{ required: true, message: '请上传作业' }]
})

const search = ref({
  activityHomework: {
    title: ''
  },
  page: 1,
  'per-page': 20
})

const data = ref([])
const isLoading = ref(false)
// 获取我的课表table数据
function getTable() {
  isLoading.value = true
  API.myActivityhomeworkList(search.value).then(res => {
    isLoading.value = false
    if (+res.code === 200) {
      data.value = res.data.list || []
    }
  })
}

/* 获取当前学年、学期、周数 */

// 打开课程弹窗

/* 搜索 */
const onSubmit = () => {
  getTable(search.value)
}

const form = ref(null)
/* 重置 */
const reset = () => {
  form.value.resetFields()
  getTable()
}

const dialogVisible = ref(false)

const handleClose = () => {
  if (isSubmitLoading.value) {
    Message.error('正在提交中，请稍后')
    return
  }
  fileFormRef.value.resetFields()
  dialogVisible.value = false
}
const isSubmitLoading = ref(false)
const fileFormRef = ref(null)
const SubmitEvent = () => {
  fileFormRef.value.key = +new Date()
  fileFormRef.value.validate(valid => {
    if (valid) {
      isSubmitLoading.value = true
      API.myActivityhomeworkUpload({ ...fileForm.value, file: fileForm.value.file.map(el => ({ name: el.name, url: el.url })) })
        .then(res => {
          isSubmitLoading.value = false
          if (+res.code === 200) {
            handleClose()
            getTable()
          } else {
            Message.error(res.msg)
          }
        })
        .catch(() => {
          isSubmitLoading.value = false
        })
    }
  })
}

const homeWorkInfo = ref({})
const extendUpdata = ref({})
const handleOpen = row => {
  fileForm.value.id = row.id
  fileForm.value.file = row.homework_score_file || []
  fileForm.value.key = Date.now()
  homeWorkInfo.value = row
  dialogVisible.value = true
  extendUpdata.value = {
    source: 'activity-homework',
    source_id: fileForm.value.id
  }
}
onMounted(() => {
  Store.dispatch('common/UserPortalData')
  getTable()
})
</script>

<style lang="scss" scoped></style>
